import { textStyle } from '@themes/mixins';
import styled, { css } from 'styled-components';

import { FormSectionTitleTypes } from '../../enums';

export const Title = styled.div<{ $type: FormSectionTitleTypes }>`
  width: 100%;
  margin: 8px 0 4px;

  ${({ $type }) =>
    $type === FormSectionTitleTypes.primary &&
    css`
      ${textStyle({
        color: 'textPrimary',
        lineHeight: 1,
        size: '15px',
        weight: 500,
        textAlign: 'left',
      })};
    `}

  ${({ $type }) =>
    $type === FormSectionTitleTypes.secondary &&
    css`
      ${textStyle({
        color: 'primary',
        lineHeight: 1,
        size: '15px',
        weight: 600,
        textAlign: 'left',
      })};
    `}
`;
